import { useState } from 'react';

export default function WhatsAppButton() {
  const [isPulsing, setIsPulsing] = useState(true);

  return (
    <a
      href="https://wa.me/905070034228"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 z-50 cursor-pointer group"
      onMouseEnter={() => setIsPulsing(false)}
      onMouseLeave={() => setIsPulsing(true)}
    >
      <div className="relative">
        {isPulsing && (
          <div className="absolute inset-0 bg-accent-green rounded-full animate-ping opacity-75"></div>
        )}
        <div className="relative w-16 h-16 bg-accent-green rounded-full flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform duration-300">
          <i className="ri-whatsapp-line text-3xl text-white"></i>
        </div>
      </div>
    </a>
  );
}